export const GET_CURRENT_USER_SUCCESS = "GET_CURRENT_USER_SUCCESS";
export const GET_CURRENT_USER = "GET_CURRENT_USER";
export const CUSTOMER_MISMATCH = "CUSTOMER_MISMATCH";
export const UPDATE_TERMS_ACCEPTED = "UPDATE_TERMS_ACCEPTED";
